const comparisonData = [
  { feature: 'Product Discovery', traditional: 'Slow', spreadsheet: 'Organized' },
  { feature: 'Product Categories', traditional: 'Limited', spreadsheet: 'Structured' },
  { feature: 'Side-by-Side Comparison', traditional: 'Difficult', spreadsheet: 'Easy' },
  { feature: 'Beginner Experience', traditional: 'Confusing', spreadsheet: 'Simple' },
  { feature: 'Research Time', traditional: 'Hours', spreadsheet: 'Minutes' },
  { feature: 'Product Organization', traditional: 'Scattered', spreadsheet: 'Curated' },
];

export default function ComparisonTable() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="w-full max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="font-label text-xs text-primary-600 tracking-[0.2em] uppercase mb-3">
            Why Spreadsheets Win
          </p>
          <h2 className="section-title mb-3">
            SuperBuy Spreadsheet vs Traditional Searching
          </h2>
          <p className="section-subtitle mx-auto">
            See how organized spreadsheets outperform manual searching in every aspect of product discovery.
          </p>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-background-100">
                  <th className="text-left px-6 py-4 font-label text-xs text-foreground-500 uppercase tracking-wider whitespace-nowrap">
                    Feature
                  </th>
                  <th className="text-center px-6 py-4 font-label text-xs text-foreground-500 uppercase tracking-wider whitespace-nowrap">
                    Traditional Search
                  </th>
                  <th className="text-center px-6 py-4 font-label text-xs text-foreground-500 uppercase tracking-wider whitespace-nowrap">
                    SuperBuy Spreadsheet
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, index) => (
                  <tr
                    key={row.feature}
                    className={`border-t border-background-100 ${
                      index % 2 === 0 ? 'bg-white' : 'bg-background-50'
                    }`}
                  >
                    <td className="px-6 py-4 font-body text-sm text-foreground-800 font-medium whitespace-nowrap">
                      {row.feature}
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className="inline-flex items-center gap-1.5 text-sm text-foreground-400 font-body">
                        <i className="ri-close-circle-line text-red-400"></i>
                        {row.traditional}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className="inline-flex items-center gap-1.5 text-sm text-accent-600 font-body font-medium">
                        <i className="ri-checkbox-circle-line"></i>
                        {row.spreadsheet}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}